import React from "react";
import { money, PAYMENT_METHODS, paymentLabel } from "@/lib/helpers";

// Composant partagé par Rentabilité et Journal.
const pct = (part, total) => `${new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 1 }).format((part / total) * 100)} %`;

// Rentrées par mode : modes à 0 masqués, « Non renseigné » seulement s'il pèse, rien si aucune rentrée.
export default function MethodBreakdown({ byMethod, revenue, cur, title = "Rentrées par mode de paiement" }) {
  if (!byMethod || !(revenue > 0)) return null;
  const rows = [
    ...PAYMENT_METHODS.map((p) => ({ key: p.value, label: paymentLabel(p.value), amount: byMethod[p.value] || 0 })),
    { key: "non_renseigne", label: "Non renseigné", amount: byMethod.non_renseigne || 0 },
  ].filter((r) => r.amount > 0);
  return (
    <div className="bg-card border border-border rounded-2xl shadow-card p-5" data-testid="method-breakdown">
      <div className="text-xs uppercase tracking-overline text-muted-foreground mb-4">{title}</div>
      <div className="space-y-3">
        {rows.map((r) => {
          const cash = r.key === "especes";
          return (
            <div key={r.key} className={cash ? "rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 p-3" : "px-3"} data-testid={`method-row-${r.key}`}>
              <div className="flex items-baseline justify-between gap-3">
                <span className={cash ? "font-display font-bold" : "text-sm"}>{r.label}</span>
                <span className={cash ? "font-display font-black text-xl" : "font-medium text-sm"}>{money(r.amount, cur)} <span className="text-muted-foreground font-normal text-sm">· {pct(r.amount, revenue)}</span></span>
              </div>
              <div className="h-1.5 rounded-full bg-muted mt-2 overflow-hidden"><div className={`h-full rounded-full ${cash ? "bg-amber-500" : r.key === "non_renseigne" ? "bg-muted-foreground/40" : "bg-accent"}`} style={{ width: `${Math.min(100, (r.amount / revenue) * 100)}%` }} /></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
